//import { bus, axios, apiURL } from '../main'

/*  i'll be mixed in in Analysen.vue */

export default {
  created() { },
  computed: {
    isAST() {
      return (this.$store.state.searchStore.searchValues.tierartSelected>1);
    },
  },
  methods: {
      getBtrAgis(btrId){
        return this.$store.state.betriebeStore.betriebe.list.filter(btr => btr.ID == btrId)[0].AGIS
      },
      getChart: function () {
        alert('mixin called analysenlänge = ' + this.analysen.length)
      },
      setChartSerie: function (selectedChart, betriebe) { // selectedChart = 'MPDZELLEN'
        let series = [];
        betriebe.forEach(btrId => {
          selectedChart.split(',').map(item => { // spezialfall:  "MPDFETT,MPDEIWEISS"
            /* die Fields(Analysen/data/fields) sind für die Tabelle bereits ausgefüllt und werden hier ausgelesen*/
            var objX = this.fields.find(function (obj) { return obj.key === item })
            if (!Object.prototype.hasOwnProperty.call(objX, "threshold") || this.isAST) {
              this.$refs["charts"].setGrenzwert();
            }
            else {
              this.$refs["charts"].setGrenzwert(objX.threshold);
            }
            series.push(this.buildCS(item, objX.label,btrId));
          }) 
        }) 
        /* z.B. BG Neuenschwander
        [ {"data":[[1527544800000,3000],[1528754400000,14000],[1529791200000,6000],[1531000800000,2000],[1533420000000,4000],[1534802400000,5000],[1536012000000,3000],[1537740000000,7000],[1539468000000,3000],[1540159200000,4000]],
          "name":"Keime (Anzahl/ml) 51814"},
          {"data":[],"name":"Keime (Anzahl/ml) 10230"},
          {"data":[],"name":"Keime (Anzahl/ml) 10233"}]
        */  
       
        this.$refs["charts"].setChartSeries(series);
      },
      buildCS(row, name,betriebsId) {
        let utcOffset = 2*60*60*1000; /* js date = GMT  das Textdatum aus der DB ist BernZeit */
        let seriesX = { data: [], name: name + ' '+this.getBtrAgis(betriebsId)};

        //return [[Date.UTC(1970, 9, 21), 0], [Date.UTC(1970, 10, 4), 0.28]];
        this.analysen.map(function (item) {
          //nur für Analysen, keine Mittelwerte
          /*
          if (item.ANATYPCODE == "MP") {
            seriesX.data.push([
              Date.parse(item.MPDDATUM),
              String(item[row]).length > 0 ? item[row] : 0
            ])
          }
          */
           if (item.MPDBASBTRID == betriebsId) {
            seriesX.data.push([
              Date.parse(item.MPDDATUM)+utcOffset,
              String(item[row]).length > 0 ? item[row] : 0
            ])
          }
        })
        seriesX.data.sort(function (a, b) {return a[0] - b[0];})
        return seriesX
      }
    }
  }